/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

module.exports = reEvaluate;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_reEvaluate.js
// module id = 4301
// module chunks = 168707334958949